import type { MessageDescriptor } from 'react-intl';

import { BillingPlanIds, isStarterPlan, isStandardPlan } from '../../../../../../enums/billing-plan-ids';

import { messages } from './messages';

type DowngradeConfirmationContent = {
  bannerMessage?: MessageDescriptor;
  primaryMessage: MessageDescriptor;
  featureMessages: ReadonlyArray<MessageDescriptor>;
};

const FREE_CONTENT: DowngradeConfirmationContent = {
  bannerMessage: messages.userRoleWarning,
  primaryMessage: messages.freeDowngradePrimaryText,
  featureMessages: [],
};

const STARTER_CONTENT: DowngradeConfirmationContent = {
  bannerMessage: messages.userRoleWarning,
  primaryMessage: messages.downgradePrimaryText,
  featureMessages: [
    messages.userSeats,
    messages.unlimitedAutomationRules,
    messages.customTrackingPortal,
    messages.inventoryManagement,
    messages.advancedAnalytics,
  ],
};

const STANDARD_CONTENT: DowngradeConfirmationContent = {
  primaryMessage: messages.downgradePrimaryText,
  featureMessages: [
    messages.dedicatedAccountManager,
    messages.userSeats,
    messages.advancedInventoryManagement,
    messages.autoSplitShipments,
    messages.CubiscanIntegration,
    messages.ODBCIntegration,
  ],
};

export const getDowngradeConfirmationContent = (
  billingPlanId: string | number | null | undefined,
): DowngradeConfirmationContent | undefined => {
  if (billingPlanId == null) return undefined;

  const parsed = typeof billingPlanId === 'number' ? billingPlanId : parseInt(String(billingPlanId), 10);

  if (parsed === BillingPlanIds.Free2025Q2) return FREE_CONTENT;
  if (isStarterPlan(billingPlanId)) return STARTER_CONTENT;
  if (isStandardPlan(billingPlanId)) return STANDARD_CONTENT;

  return undefined;
};
